export const TIMEZONE_ALIAS_MAP = {
  // India
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Delhi': 'Asia/Kolkata',
  'Asia/Madras': 'Asia/Kolkata',

  // USA
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  'US/Alaska': 'America/Anchorage',
  'US/Hawaii': 'Pacific/Honolulu',
  'US/Arizona': 'America/Phoenix',
  'US/East-Indiana': 'America/Indiana/Indianapolis',
  'US/Michigan': 'America/Detroit',

  // Europe
  'Europe/Kiev': 'Europe/Kyiv',
  'Europe/Belfast': 'Europe/London',

  // Asia
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Asia/Chungking': 'Asia/Shanghai',
  'Asia/Harbin': 'Asia/Shanghai',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Dacca': 'Asia/Dhaka',
  'Asia/Ujung_Pandang': 'Asia/Makassar',
  'Asia/Thimbu': 'Asia/Thimphu',
  'Asia/Tel_Aviv': 'Asia/Jerusalem',

  // Africa
  'Africa/Asmera': 'Africa/Asmara',
  'Africa/Timbuktu': 'Africa/Bamako',

  // South America
  'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
  'America/Cordoba': 'America/Argentina/Cordoba',
  'America/Mendoza': 'America/Argentina/Mendoza',

  // UTC/GMT
  GMT: 'UTC',
  'Etc/UTC': 'UTC',
  'Etc/GMT': 'UTC',
  Greenwich: 'UTC',

  // Legacy abbreviations
  EST: 'America/New_York',
  CST: 'America/Chicago',
  MST: 'America/Denver',
  PST: 'America/Los_Angeles',
  HST: 'Pacific/Honolulu',
};
